import { render } from "./NewBox.vue?vue&type=template&id=747d04b6"
import script from "./NewBox.vue?vue&type=script&lang=js"
export * from "./NewBox.vue?vue&type=script&lang=js"

import "./NewBox.vue?vue&type=style&index=0&id=747d04b6&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__